import dayjs from "dayjs";

export function getDaysToDateInFutureVerbose(date: Date): string {
  const days = Math.round(dayjs(date).diff(dayjs(), "day", true));

  if (days < 1) {
    return "mniej niż dzień do wygaśnięcia";
  } else if (days === 1) {
    return "1 dzień do wygaśnięcia";
  }

  return `${days} dni do wygaśnięcia`;
}

export function getDaysToDateInFuture(date: Date): number {
  return Math.round(dayjs(date).diff(dayjs(), "day", true));
}
